import { type Common } from '../common.js';
import { type ProducedType } from '../models/flow/flowDefinition.js';
import {
  type DeleteTestPatientDataResponse,
  type TestPatientData,
  type TestPatientDataLookup,
  type TestPatientDataSummary,
} from '../models/flow/testPatientData.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/test-patients/';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(queryParams?: TestPatientDataLookup): Promise<TestPatientData[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }

  /**
   * Lookup a flow builder test patient by ehrInformationId, returning all data keyed by dataType
   */
  async findOneById(ehrInformationId: string): Promise<TestPatientDataSummary> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${ehrInformationId}`);
    return await this.common.getJSON(url);
  }

  /**
   * Create or update flow builder test patient data by ehrInformationId and dataType
   */
  async createOrUpdate(args: {
    ehrInformationId: string;
    dataType: ProducedType;
    mock: any;
  }): Promise<TestPatientDataSummary> {
    const { ehrInformationId, dataType, mock } = args;
    const url = this.common.constructPath(`${this.baseEndpoint}/${ehrInformationId}/${dataType}`);
    return await this.common.postJSON(url, mock);
  }

  /**
   * Delete flow builder test patient data by ehrInformationId and dataType
   */
  async delete(args: {
    ehrInformationId: string;
    dataType: ProducedType;
  }): Promise<DeleteTestPatientDataResponse> {
    const { ehrInformationId, dataType } = args;
    const url = this.common.constructPath(`${this.baseEndpoint}/${ehrInformationId}/${dataType}`);
    return await this.common.deleteJSON(url);
  }
}
